"use strict";

var LoggerInstance = require("js-logger").get("ValidationHelper");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

module.exports = {
	removeBetterValidationPopup($inputs) {
		$inputs.each((index, element) => {
			//If the element is valid, remove the tooltip
			if (element.validity.valid) {
				$(element).removeAttr("aria-invalid").prev(".better-validity-tooltip").attr("aria-hidden", true);
			}
		});
	},

	// valid options:
	// * all - Validate all inputs in the current DOM is truthy
	showInvalidInputsDialog() {
		var errorMessage = "";

		this._errorMessages.forEach(message => {
			errorMessage += errorMessage !== "" ? "\n" : "";
			errorMessage += message;
		});

		var setFocus = () => {
			var invalidInputs = $(".invalid").first().filter(":visible:enabled");
			if (invalidInputs.length) {
				invalidInputs[0].focus();
			}
		};

		if (errorMessage) {
			BootstrapPrompt.alert(errorMessage, () => {
				// Without the defer, the input is focused before the dialog is fully closed, and focus goes to the
				// window instead of the input.
				_.defer(setFocus);
			});
		} else {
			setFocus();
		}
	},

	// * components - A list of jQuery component objects to validate.
	validate(options) {
		var deferred = new $.Deferred();
		this._initializeValidation();
		var innerDeferred;

		// May need to create a local variable if we want to support a combination of parent and individual.
		if (options.all) {
			innerDeferred = this._validateAll();
		} else if (options.components) {
			innerDeferred = this._validateComponents(options.components);
		}

		innerDeferred.always(() => {
			if (options.doNotShowAlert) {
				//The return type is different if doNotShowAlert is set.
				deferred.resolve({
					errorMessages: this._errorMessages,
					isValid: this._isValid
				});
			}

			//Returing a boolean whether isValid or not.
			deferred.resolve(this._handleInvalidAndReturn(options));
		});

		return deferred;
	},

	// Reset all internal variables;
	_initializeValidation() {
		this._isValid = true;
		this._errorMessages = [];
	},

	_validateAll() {
		var deferred = new $.Deferred();
		// From jQuery documentation <https://api.jquery.com/enabled-selector/>:
		// - The :enabled selector should only be used for selecting HTML elements that support the disabled attribute (<button>, <input>, <optgroup>, <option>, <select>, and <textarea>).
		var customSelector = $("[data-has-custom-validator]:visible").not("input,select,option,textarea,button,optgroup")
			.add("input[data-has-custom-validator]:visible:enabled")
			.add("select[data-has-custom-validator]:visible:enabled")
			.add("option[data-has-custom-validator]:visible:enabled")
			.add("textarea[data-has-custom-validator]:visible:enabled")
			.add("button[data-has-custom-validator]:visible:enabled")
			.add("optgroup[data-has-custom-validator]:visible:enabled");
		this._customValidate($(customSelector)).always(() => {
			deferred.resolve();
		});

		// get all inputs in the DOM
		var $inputs = $("input,select").filter(":visible:enabled");
		$inputs.each(this._validateInput.bind(this));

		return deferred;
	},

	_validateComponents(components) {
		var deferred = new $.Deferred();
		var customValidatorDeferreds = [];
		components.forEach($component => {
			// From jQuery documentation <https://api.jquery.com/enabled-selector/>:
			// - The :enabled selector should only be used for selecting HTML elements that support the disabled attribute (<button>, <input>, <optgroup>, <option>, <select>, and <textarea>).
			var customSelector = $component.find("[data-has-custom-validator]:visible").addBack("[data-has-custom-validator]:visible").not("input,select,option,textarea,button,optgroup")
				.add($component.find("input[data-has-custom-validator]:visible:enabled").addBack("input[data-has-custom-validator]:visible:enabled"))
				.add($component.find("select[data-has-custom-validator]:visible:enabled").addBack("select[data-has-custom-validator]:visible:enabled"))
				.add($component.find("option[data-has-custom-validator]:visible:enabled").addBack("option[data-has-custom-validator]:visible:enabled"))
				.add($component.find("textarea[data-has-custom-validator]:visible:enabled").addBack("textarea[data-has-custom-validator]:visible:enabled"))
				.add($component.find("button[data-has-custom-validator]:visible:enabled").addBack("button[data-has-custom-validator]:visible:enabled"))
				.add($component.find("optgroup[data-has-custom-validator]:visible:enabled").addBack("optgroup[data-has-custom-validator]:visible:enabled"));
			customValidatorDeferreds.push(this._customValidate(customSelector));

			var $inputs = $component.find('input,select').addBack('input,select').filter(":visible:enabled");

			// Mark input as invalid and add a namespaced handler to re-check validity.
			$inputs.each(this._validateInput.bind(this));
		});

		if (customValidatorDeferreds.length) {
			$.when(...customValidatorDeferreds).always(() => {
				deferred.resolve();
			});
		} else {
			deferred.resolve();
		}

		return deferred;
	},

	_customValidate($elementsWithCustomValidators) {
		var deferred = new $.Deferred();
		var customValidatorDeferreds = [];

		$elementsWithCustomValidators.each((index, element) => {
			var $element = $(element);

			if ($element.data("customValidator") !== undefined && (typeof $element.data("customValidator") === "function")) {
				var response = $element.data("customValidator")();

				if (response && response.deferred) {
					response.deferred.always((deferredResponse) => {
						if (deferredResponse && !deferredResponse.isValid) {
							this._markAsInvalid($element, deferredResponse.errorMessages);
						}
					});
					customValidatorDeferreds.push(response.deferred);
				} else if (response && !response.isValid) {
					this._markAsInvalid($element, response.errorMessages);
				}
			}
		});

		if (customValidatorDeferreds.length) {
			$.when(...customValidatorDeferreds).always(() => {
				deferred.resolve();
			});
		} else {
			deferred.resolve();
		}

		return deferred;
	},

	_validateInput(index, input) {
		var minPhoneNumberLength = 7; // This is a valid min-length excluding country code and area code for all countries except Saint Helena (5) and Niue (4)
		var $input = $(input);

		if (!input.validity.valid) {
			//For better form-validation messages, you can put a message in the title attribute designating the field requirements.
			var title = $(input).prop("title") || window.FORM_VALIDATION_MESSAGES.REQUIRED_FIELDS;
			this._markAsInvalid($input, [title]);
		} else if ( // legacy code support so we do not have to deploy a breaking change for every text input in the entire application.
			$input.prop("tagName") !== "SELECT" &&
			$input.prop("type") !== "radio" &&
			$input.prop("type") !== "checkbox" &&
			$input.prop("required") &&
			!$input.prop("pattern")) { // If there is no HTML5 pattern attribute, then we have to perform additional checks for white space
			if (
				($input.attr("data-component") !== "accountPhoneNumber" && !$input.val().trim().length) || // Validation for fields which are not phone numbers
				($input.attr("data-component") === "accountPhoneNumber" && $input.val().replace(/[\D]/g, "").length < minPhoneNumberLength)) { // Phone number validation - replace non-digits with empty string
				this._markAsInvalid($input, [window.FORM_VALIDATION_MESSAGES.REQUIRED_FIELDS]);
			}
		}
	},

	_markAsInvalid($input, errorMessages) {
		$input.addClass("invalid");
		$input.on("change.invalidInput", this._onUpdateInvalidInput.bind(this, $input));
		this._isValid = false;

		if (errorMessages && errorMessages.length > 0) {
			errorMessages.forEach(message => {
				if (!this._errorMessages.includes(message)) {
					this._errorMessages.push(message);
				}
			});
		}
	},

	_handleInvalidAndReturn(options) {
		options = options || {};
		if (!this._isValid && !options.doNotShowAlert) {
			this.showInvalidInputsDialog();
		}

		return this._isValid;
	},

	// Listener to remove the invalid class when an input becomes valid again.
	_onUpdateInvalidInput($input) {
		var validity = $input[0].validity;
		if (validity && validity.valid) {
			this._removeChangeHandler($input);
		}
	},

	// Remove the namespaced handler that we created while validating.
	_removeChangeHandler($input) {
		$input.off("change.invalidInput");
		$input.removeClass("invalid");
	}
};



// WEBPACK FOOTER //
// ./Javascript/commonComponents/ValidationHelper.jsx